import TabStack from '@/components/Navigation/TabStack';

export const unstable_settings = {
  initialRouteName: '(main)',
};

export default function PrivateTabsTeamLayoutRoute() {
  return <TabStack />;
}
